var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CastBadge',{class:_vm.className,attrs:{"icon":"hands-helping","label":_vm.supportLabel,"description":_vm.pending ? 'Support request is pending Kiswe Studio team approval' : 'Support level: ' + _vm.supportLabel,"compact":_vm.compact}})}
var staticRenderFns = []

export { render, staticRenderFns }